<style>
html,body{height: 100%;}
#fseid:after {
  clear: both;
  content: "";
  width: 0;
  height: 0;
  display: block;
  visibility: hidden;
}

#fseid{
  border-bottom:1px solid #dddddd;
  padding-bottom: 10px;
}
.typepageheight{
  height: 100%;
}
</style>
<template>
        <div v-title data-title="产品分类" style="height:100%;">
        <div class="search-bar" v-if="!issearch" style="background: #ee7310;">
      <div class="search-logo"><img src="../../assets/img/logo.png"/></div>
      

      <div class="input" @click="showsearch()">
        <i class="van-icon">
          <div class="van-image van-icon__image">
            <img
              src="data:image/png;base64,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"
              class="van-image__img"
              style="object-fit: contain;"
            />
          </div>
        </i>
        <span class="placeholder" v-if="productName==''">搜索商品</span>
        <span class="placeholder" v-if="productName!=''">{{productName}}</span>
      </div>
      <div class="wrap">
        <div class="collect">
          <img
            v-if="WechatLogoUrl!=''"
            :src="WechatLogoUrl"
            width="40"
            style="border-radius: 50px;"
          />
          <img
            v-if="WechatLogoUrl==''"
            src="../../assets/logo.png"
            width="40"
            style="border-radius: 50px;"
          />
        </div>
      </div>
    </div>

    <div class="my-search" v-if="issearch" style="background:#f3f3f3">
      <div class="search-top">
        <div class="van-search van-search--show-action" style="background:#ffffff;">
          <div class="van-search__content van-search__content--round">
            <div class="van-cell van-cell--borderless van-field">
              <div class="van-field__left-icon">
                <i class="van-icon">
                  <div class="van-image van-icon__image">
                    <img
                      src="data:image/png;base64,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"
                      class="van-image__img"
                      style="object-fit: contain;"
                    />
                  </div>
                  
                </i>
              </div>
              <div class="van-cell__value van-cell__value--alone">
                <div class="van-field__body">
                  <input
                    type="search"
                    v-model="productName"
                    placeholder="请输入搜索关键词"
                    class="van-field__control"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="van-search__action">
            <div @click="issearch=false">
              <span v-if="productName!=''" @click="onSearch()">搜索</span>
              <span v-if="productName==''">取消</span>
            </div>
          </div>
        </div>
      </div>
      <div class="hot-search">
        <!---->
        <!---->
        <div class="search-tags"></div>
        <p class="search-title">热门搜索</p>
        <div class="search-tags">
          <span
            v-for="(s,$index) in this.hotsearchtag"
            :key="$index"
            @click="searchtags(s)"
            class="van-tag van-tag--round van-tag--default"
            style="background-color: rgb(233, 233, 233); color: rgb(90, 90, 90);"
          >{{s}}</span>
        </div>
         </div>
    </div>
        <div class="sort-list" v-if="!issearch">
            <ul v-if="producttype.length>0" class="sort-t" style='padding-top: 60px;'>
                <li :class="p.sortindex==currentTap?'active':''" :style="p.sortindex==currentTap?'background: #fff!important;height: 30px!important;line-height: 30px!important;text-align: center!important;padding: 15px 0!important;':'height: 30px!important;line-height: 30px!important;text-align: center!important;padding: 15px 0!important;'" v-for="(p,$index) in producttype" :key="$index">
                    <a :style="p.sortindex==currentTap?'border-left: 3px solid #ff7739!important;color: #ff7739!important;':'color: #000!important;'"  v-on:click="GoToThis(p.id,p.sortindex)" data-id="p.id">{{p.name}}</a>
                </li>
            </ul>
            
            <div class="sort-con" style='padding-top:75px'>
                <div class="list-t" id="shuma">{{currentFirstMenu}}</div>
                    <div v-for="(p,$index) in producttypeSecchild" :key="$index" >
                        <div v-if="p.children.length>0" class="sort-con-t">{{p.name}}</div>
                        <div v-if="p.children.length>0" id=fseid>
                             <div class="product-list" v-for="(s,$index) in p.children" :key="$index" style='float: left; width: 30%;'>
                                <a style='width: 90%;' v-on:click="GoToThisMenu(s.id,s.name)"><img :src='s.icon'><span>{{s.name}}</span></a>
                             </div>
                        </div>
                    </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Toast } from "we-vue";
import Vue from "vue";
import thumb from "../../assets/logo.png";
import { Dialog } from "we-vue";
import wx from "weixin-js-sdk";
import { debug } from "util";
export default {
  name: "sort",
  data: function() {
    return {
      order: 1,
      topId: 1,
      producttype: [],
      producttypeSecchild: [],
      producttypechild: [],
      currentFirstMenu: "",
      currentSecondMenu: "",
      currentTap: 1,
      issearch: false,
      disid: "",
      borwser: this.GLOBAL.borwser,
      LoginType: -1, //(-1=未登录/4=家游客/5=直客)
      FirstInit: true, //首次加载（加载分页防止重复请求）
      popupVisible4: false,
      popupVisible3: false,
      popupVisiblediy: false,
      logourl: thumb,
      productName: "",
      scenicareaId: null,
      holtelId: null,
      formset: [],
      PageSize: 10,
      PageNum: 1,
      TotalCount: -1,
      IsOrderByPriceAsc: null,
      IsOrderBySaleCountDesc: null,
      isCheckRole: 0, //是否校验角色
      issearch: false,
      orderlist: [],
      currentproductType: 0,
      currentTab: 0,
      hotsearchtag: ["摩飞", "大宇", "北鼎", "法格", "BRUNO", "海氏", "康巴赫", "卡特马克", "科西"],
      WechatLogoUrl:''
    };
  },
  created: function() {
    this.InitPage();
    this.AccessWxLogo();
  },
  methods: {
    InitPage: function(topId) {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/tbproduct/accessAllProductType", {
          params: {
            topId: 1
          }
        })
        .then(function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            //提示绑定成功
            this.producttype = rep.Data;
            this.currentFirstMenu = rep.Data[0].name;
            this.producttypeSecchild = rep.Data[0].children;
          } else {
            Toast.fail(rep.Message);
          }
        });
    },
    AccessWxLogo: function() {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/tbproduct/accessauth", {})
        .then(function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            //提示绑定成功
            this.WechatLogoUrl = rep.Data;
          } else {
            Toast.fail(rep.Message);
          }
        });
    },
    GoToThis: function(id, sortId) {
      for (var i = 0; i < this.producttype.length; i++) {
        if (this.producttype[i].id == id) {
          this.currentTap = sortId;
          this.currentFirstMenu = this.producttype[i].name;
          this.producttypeSecchild = this.producttype[i].children;
        }
      }
    },
    GoToThisMenu: function(id, name) {
      this.$router.push({
        path: "/page/mustpushtoday",
        query: {
          typeName: encodeURI(name),
          type: id
        }
      });
    },
    onSearch(val) {
      this.$router.push({
        path: "/page/mustpushtoday",
        query: {
          keyword: encodeURI(this.productName)
        }
      });
    },
    showsearch: function() {
      this.issearch = !this.issearch;
    },
    searchtags: function(v) {
      this.productName = v;
      this.showsearch();
      this.onSearch();
    }
  }
};
</script>

<style>
.combo-price {
  color: red;
  font-size: 1.17rem;
}
.combo-qi {
  font-size: 0.75rem;
  color: #999;
}
.wv-button {
  float: right;
  margin-right: 5%;
}
.weui-form-preview__hd {
  line-height: 1.5em;
}

.weui-media-box__date {
  float: right;
}

.weui-form-preview__btns {
  width: 100%;
  text-align: right;
  padding-right: 20px;
  padding-bottom: 5px;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  color: #3cc51f;
  display: block;
  flex: 1;
  position: relative;
}

.weui-media-box__content {
  text-align: right;
  float: right;
  width: 100%;
  font-size: 14px;
}

.fontsf {
  font-size: 14px;
  color: #000;
}

.fontsn {
  font-size: 14px;
}

.weui-form-preview__border {
  height: 10px;
  background-color: #efeff4;
}

.weui-search-bar {
  z-index: 9999;
}

.popup {
  z-index: 9998;
  position: relative;
  background-color: #fff;
  line-height: 2em;
  padding-top: 70px;
  font-size: 1.5rem;
}

.search_left {
  width: 50%;
  text-align: center;
  float: left;
  background-color: #fff;
}

.weui-cells {
  margin-top: 0px;
}
.weui-zdycolors {
  color: #999;
}
.weui-spaces {
  height: 10px;
  background-color: #efeff4;
}
.needtomargin-top-wx {
  padding-top: 40px;
}
.needtomargin-top-common {
  padding-top: 90px;
}
</style>



// WEBPACK FOOTER //
// src/components/sort/sort.vue